/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { compose } from "redux";
import { t } from "i18n";

import wrapPage from "containers/page/page";
import Analytics from "./analytics";
import TopStories from "pages/analytics/components/top-stories/top-stories";

const StoryAnalytics: React.SFC<any> = (props) => {
  return <Analytics {...props} title={t("analytics.story_analytics")} Component={TopStories} />;
};

export default compose(wrapPage())(StoryAnalytics);

export { StoryAnalytics };
